const MAILTO_FALLBACK_DELAY_MS = 1500

// Note: a browser gives no signal when mailto has no handler, so if the page keeps focus after the
// click we assume nothing opened and fall back to Gmail compose (still inside the click's user activation)
export const openMailWithGmailFallback = (email: string) => {
  const timer = window.setTimeout(() => {
    cleanup()
    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`,
      '_blank',
      'noopener,noreferrer',
    )
  }, MAILTO_FALLBACK_DELAY_MS)

  const cancel = () => {
    window.clearTimeout(timer)
    cleanup()
  }
  const handleVisibility = () => document.hidden && cancel()
  const cleanup = () => {
    window.removeEventListener('blur', cancel)
    document.removeEventListener('visibilitychange', handleVisibility)
  }

  window.addEventListener('blur', cancel)
  document.addEventListener('visibilitychange', handleVisibility)
}
